import React from "react";

const Pill = ({text,backgroundColor}) => {
  return (
    <div
      className={"flex items-center  gap-2 px-3 py-1 rounded-full w-fit"}
      style={{ backgroundColor }}
    >
      <div className="h-2 w-2 rounded-full bg-gradient-to-r from-[#F5B800] via-[#FF7B00] to-[#FF4C00]" />
      <div className="text-[13px] bg-gradient-to-r from-[#F5B800] via-[#FF7B00] to-[#FF4C00] bg-clip-text text-transparent tracking-widest uppercase">
        {text}
      </div>
    </div>
  );
};

export default Pill;
